module.exports = __webpack_public_path__ + "static/media/full-text-1.7b753673.png";